import { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { resolveTheme } from "./themeResolver";
import { buildMuiTheme } from "./createMuiTheme";
import { applyCSSVariables, generateCSSVariables } from "./tokenEngine";
import { useTenant } from "../contexts/TenantService";

export const ThemeContext = createContext(null);

export const ThemeProvider = ({ brandId, children }) => {
  const [muiTheme, setMuiTheme] = useState(null);
  const [tokens, setTokens] = useState(null);

  const { tenantSvc } = useTenant();

  useEffect(() => {
    const loadTheme = async () => {
      try {
        const themeTokens = await resolveTheme(brandId, tenantSvc);
        const CSSVariables = generateCSSVariables(themeTokens);
        applyCSSVariables(CSSVariables);

        const theme = buildMuiTheme(themeTokens);

        setMuiTheme(theme);
        setTokens(themeTokens);
      } catch (error) {
        console.error("Error loading theme:", error);
      }
    };

    loadTheme();
  }, [brandId, tenantSvc]);

  if (!muiTheme) return null;

  return (
    <ThemeContext.Provider value={tokens}>
      <MuiThemeProvider theme={muiTheme}> {children} </MuiThemeProvider>
    </ThemeContext.Provider>
  );
};

ThemeProvider.propTypes = {
  brandId: PropTypes.string,
  children: PropTypes.node,
};
